import React from "react";
import {
  FiSearch,
  FiPenTool,
  FiLayers,
  FiCheckCircle,
  FiSend,
} from "react-icons/fi";
import "./DesignProcess.css";

const DesignProcess = () => {
  return (
    <section className="oglitz-design-process">
      <div className="oglitz-design-process__container">
        {/* Header */}
        <div className="oglitz-design-process__header">
          <span className="oglitz-design-process__badge">
            Our Design Process
          </span>

          <h2 className="oglitz-design-process__title">
            A Simple, Proven Process
            <span> That Delivers Results</span>
          </h2>

          <p className="oglitz-design-process__subtitle">
            From discovery to delivery, our structured design workflow ensures
            clarity, quality, and consistent outcomes.
          </p>
        </div>

        {/* Steps */}
        <div className="oglitz-design-process__steps">
          <Step
            icon={<FiSearch />}
            step="01"
            title="Discovery & Briefing"
            text="We understand your brand, goals, audience, and expectations before starting."
          />

          <Step
            icon={<FiPenTool />}
            step="02"
            title="Creative Concept"
            text="Our designers craft concepts aligned with your brand strategy and objectives."
          />

          <Step
            icon={<FiLayers />}
            step="03"
            title="Design Execution"
            text="We design high-quality visuals optimized for platforms and performance."
          />

          <Step
            icon={<FiCheckCircle />}
            step="04"
            title="Review & Revisions"
            text="You review the designs and request refinements to perfect the output."
          />

          <Step
            icon={<FiSend />}
            step="05"
            title="Final Delivery"
            text="We deliver production-ready files on time, ready for immediate use."
          />
        </div>
      </div>
    </section>
  );
};

const Step = ({ icon, step, title, text }) => {
  return (
    <div className="oglitz-design-process__step">
      <div className="oglitz-design-process__icon">{icon}</div>

      <div className="oglitz-design-process__content">
        <span className="oglitz-design-process__step-number" aria-hidden="true">
          {step}
        </span>

        <h4 className="oglitz-design-process__step-title">{title}</h4>
        <p className="oglitz-design-process__step-text">{text}</p>
      </div>
    </div>
  );
};

export default DesignProcess;
